import { all, takeEvery, call, put } from 'redux-saga/effects';
import * as ACTION from '../constants/signupActionTypes'
import {signupRequest, signupDataRequest, signup, verifyOtp, getStripeSubscriptionData, signupWithStripeUniqueCode} from "../api/signupApi";
import Utils from "../helpers/Utils";
import {STRIPE_PAYMENT_USER_TYPE} from "../constants/CoreConstants";

function* signupWatcher() {
    yield takeEvery(ACTION.SIGNUP_ATTEMPT, attemptSignupFlow)
    yield takeEvery(ACTION.FETCH_SIGNUP_DATA, fetchSignUpDataFlow)
    yield takeEvery(ACTION.SIGN_UP_PROCESS, signupFlow)
    yield takeEvery(ACTION.OTP_VERIFY_PROCESS, verifyOTPFlow)
    yield takeEvery(ACTION.SIGNUP_WITH_STRIPE_UNIQUE_CODE, signupWithStripeUniqueCodeSaga)
}

function* attemptSignupFlow(action) {
    try {
        const response = yield call(signupRequest, action.payload);
        let responseData = response.data;
        if (responseData.status) {
            yield put({type: ACTION.SIGNUP_SUCCESS, payload: true});
        } else {
            console.log('not ok');
        }

    } catch (error) {
        console.log(error);
    }

}

function* fetchSignUpDataFlow (action) {
    const { payload } = action;
    try {

        let apiCall = [call(signupDataRequest, payload.payload)];

        const [signupResponse] = yield all(apiCall);

        const signupResponseData = signupResponse.data;

        if (signupResponseData.status) {
            yield put({type: ACTION.FETCH_SIGNUP_DATA_SUCCESS, payload: signupResponseData.data});
        } else {
            Utils.handleException(signupResponseData.message);
        }

        if (payload.callback) {
            payload.callback(signupResponse?.data);
        }
    } catch (error) {
        Utils.handleException(error);
    }
}

function* signupFlow (action) {
    try {
        const response = yield call(signup, action.payload?.payload ? action.payload?.payload : action.payload);
        let responseData = response.data;

        if (responseData.status === 'success') {
            if(responseData.userOtp)
            {
                let apiKey = responseData.api_key;
                yield put({type: ACTION.SIGN_UP_SUCCESS, payload: {apiKey}});
            }else{
                yield put({type: ACTION.SIGN_UP_SUCCESS, payload: {}});
            }
            if(action.payload?.callback !== undefined){
                action.payload.callback() 
            }
        } else {
            yield put({type: ACTION.UPDATE_SUBMITTING, payload: false});
            yield put({type: ACTION.UPDATE_ERROR_MESSAGE, payload: responseData.html});
            window.showNotification("error", responseData.html);
            Utils.handleException(responseData.html);
        }
    } catch (error) {
        Utils.handleException(error);
    }
}

function* signupWithStripeUniqueCodeSaga (action) {
    try {
        const response = yield call(signupWithStripeUniqueCode, action.payload?.payload ? action.payload?.payload : action.payload);
        let responseData = response.data;

        if (responseData.status === 'success') {
            if(responseData.userOtp)
            {
                let apiKey = responseData.api_key;
                yield put({type: ACTION.SIGNUP_WITH_STRIPE_UNIQUE_CODE_SUCCESS, payload: {apiKey}});
            }else{
                yield put({type: ACTION.SIGNUP_WITH_STRIPE_UNIQUE_CODE_SUCCESS, payload: {}});
            }
            if(action.payload?.callback !== undefined){
                action.payload.callback()
            }
        } else {
            yield put({type: ACTION.UPDATE_SUBMITTING, payload: false});
            yield put({type: ACTION.UPDATE_ERROR_MESSAGE, payload: responseData.html});
            yield put({type: ACTION.SIGNUP_WITH_STRIPE_UNIQUE_CODE_FAILURE });
            window.showNotification("error", responseData.html);
            Utils.handleException(responseData.html);
        }
    } catch (error) {
        Utils.handleException(error);
    }
}

function* verifyOTPFlow (action) {
    try {
        const response = yield call(verifyOtp, action.payload.payload);
        let responseData = response.data;
        if (responseData.status === 'success') {
            yield put({type: ACTION.SIGN_UP_SUCCESS, payload: {}});
        } else if (responseData.status === 'otp-not-matched'){
            let apiKey = responseData.api_key;
            let otpError = true;
            yield put({type: ACTION.SIGN_UP_SUCCESS, payload: {apiKey:apiKey, otpError:otpError}});
        } else {
            yield put({type: ACTION.UPDATE_SUBMITTING, payload: false});

            Utils.handleException(responseData.message);
        }
        if(action.payload.callback){
            action.payload.callback()
        }
    } catch (error) {
        Utils.handleException(error);
    }
}

export default function* signupMiddleware() {
    yield all([
        signupWatcher()
    ])
}